module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/inicio/inicio.component.scss
// module id = ./src/app/pages/inicio/inicio.component.scss
// module chunks = main